import { createRoute } from '@tanstack/react-router'
import rootRoute from './rootRoute'
import type { components } from '@/lib/client'
import { errorToast, toast } from '@/components/ui'
import { $api, $client } from '@/lib/fetch'
import EntityForm from '@/components/EntityForm'
import Loader from '@/components/Loader'
import { adminRouteLoader } from '@/lib/auth'

type CreateEntity = components['schemas']['CreateEntityInputBody']

function EditEntityPage() {
  const { id } = entityEditRoute.useParams()

  const { isPending, error, data, refetch } = $api.useQuery(
    'get',
    '/api/entities/{id}',
    { params: { path: { id: parseInt(id) } } },
  )

  if (isPending) return <Loader />

  if (error) {
    return (
      <div style={{ padding: 'var(--space-20)', textAlign: 'center' }}>
        Erreur: {JSON.stringify(error)}
      </div>
    )
  }

  const onSubmit = async (update: CreateEntity) => {
    const { error: updateError } = await $client.PATCH('/api/entities/{id}', {
      params: { path: { id: parseInt(id) } },
      body: update,
    })

    if (updateError) {
      if (updateError.detail === 'validation failed') {
        const named: Record<string, string> = {}
        updateError.errors?.forEach((e) => {
          const [, name] = (e.location || '').split('body.')
          if (e.message) named[name || ''] = e.message
        })
        return named
      }
      errorToast('Échec de la mise à jour', updateError)
      return
    }

    await refetch()
    toast({ color: 'success', title: 'Entité mise à jour !' })
  }

  return (
    <EntityForm
      label="Modifier l'entité"
      onSubmit={onSubmit}
      entity={data.entity}
    />
  )
}

export const entityEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/admin/entities/$id/edit',
  loader: adminRouteLoader as any,
}).lazy(() => import('./EntityEditPage.lazy').then((m) => m.Route))

export default EditEntityPage
